import { Card } from "antd";
import React from "react";

const CustomCard = ({ children, style, className }) => {
  return (
    <Card
      className={className}
      style={{
        boxShadow: "0px 0px 6px 2px rgba(97, 96, 96, 0.1)",
        borderRadius: "14px",
        padding: 0,
        margin: 0,
        ...style,
      }}
      variant="outlined"
    >
      {children}
    </Card>
  );
};

export default CustomCard;
